import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getIsRobot } from "@faire/retailer-visitor-shared/serialized-data/getIsRobot";
import { getSettingEnableSEOLanguageSelector } from "@faire/retailer-visitor-shared/settings/getSettingEnableSEOLanguageSelector";
import { getSettingLanguageSelectorEnabled } from "@faire/retailer-visitor-shared/settings/getSettingLanguageSelectorEnabled";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { route as faireDirectRoute } from "@faire/web-api--source/routes/direct/brandAlias";
import { route as faireDirectSalesRepRoute } from "@faire/web-api--source/routes/direct/brandAlias/rep/salesRepCode";
import { route as discoverRoute } from "@faire/web-api--source/routes/discover/searchTerm";
import { route as exploreRoute } from "@faire/web-api--source/routes/explore/searchTerm";
import { route as searchRoute } from "@faire/web-api--source/routes/search";
import { useMemo } from "react";
export var useLanguage = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var _useRetailerStore = useRetailerStore([
        "showLanguageSelector",
        "showSEOLanguageSelector",
        "availableLanguageSelectorLocales"
    ]), showLanguageSelectorControl = _useRetailerStore.showLanguageSelector, showSEOLanguageSelectorControl = _useRetailerStore.showSEOLanguageSelector, availableLanguageSelectorLocalesControl = _useRetailerStore.availableLanguageSelectorLocales;
    var isLoggedInRetailerOrBrandPreview = useIsLoggedInRetailerOrBrandPreview();
    var showLanguageSelector = !getIsRobot() && getSettingLanguageSelectorEnabled();
    var showSEOLanguageSelector = useMemo(function() {
        /**
         * we want to hide language selector on discover/search and explore page
         * as search terms do not translate well
         * This would also preserve crawl budget
         */ var blocklist = [
            discoverRoute,
            searchRoute,
            exploreRoute,
            faireDirectRoute,
            faireDirectSalesRepRoute
        ];
        var hideLanguageSelector = blocklist.some(function(route) {
            return pathMatchesRoute(getCurrentPath().pathname, route);
        });
        return !!getIsRobot() && !hideLanguageSelector && !isLoggedInRetailerOrBrandPreview && getSettingEnableSEOLanguageSelector();
    }, [
        isLoggedInRetailerOrBrandPreview
    ]);
    var _getGlobalProperty;
    var availableLanguageSelectorLocales = (_getGlobalProperty = getGlobalProperty("availableLanguageSelectorLocales")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : [];
    if (shouldUseHooksMigration) {
        return {
            showLanguageSelector: showLanguageSelector,
            showSEOLanguageSelector: showSEOLanguageSelector,
            availableLanguageSelectorLocales: availableLanguageSelectorLocales
        };
    }
    return {
        showLanguageSelector: showLanguageSelectorControl,
        showSEOLanguageSelector: showSEOLanguageSelectorControl,
        availableLanguageSelectorLocales: availableLanguageSelectorLocalesControl
    };
};
